var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h6',[_c('small',{staticClass:"fw-bold"},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]}),_vm._v(":   ")],2),_c('small',{staticClass:"fw-semi-bold"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }